export default __webpack_public_path__ + "static/media/BudgetTracker.c53ae856.png";